import trackBrowse from './browse'
import trackClick from './click'
import trackScroll from './scroll'
import trackWait from './wait'
import { getTask, setTask, setDebug, getDebug, cancelTask, getContext } from './_core'
import { start as _start, markAsCompleted as _markAsCompleted, createClient } from './webApi'

export { getDebug, cancelTask, createClient }

const trackFunction = {
	browse: trackBrowse,
	click: trackClick,
	scroll: trackScroll,
	wait: trackWait
}

export const start = async (code, client, debug) => {
	const { error, completionCriteria } = await _start(code, client)
	if (error) {
		if (debug)
			console.error(`ERROR - ${error}`)
		return { error, completionCriteria:null }
	}
	else {
		if (debug) {
			console.log(`INFO - Task successfully started. ${(completionCriteria||[]).length} completion criteria successfully received:`)
			console.log(completionCriteria||[])
		}
		// completionCriteria.map(c => c.completed = true)
		if (completionCriteria)
			setTask({ code, completionCriteria })

		return { error:null, completionCriteria }
	}
}

export const markAsCompleted = async (client) => {
	const { code } = getTask() || {}
	if (code) {
		const resp = await _markAsCompleted(code, client)
		cancelTask()
		return resp
	} else {
		cancelTask()
		console.error('ERROR - Cannot mark a task as completed when the \'code\' is not found in memory.')
		return {
			error: 'Sorry, something does not seem right on your browser. Please try again. If this issue persist, try a different browser.'
		}
	}
}


export const track = () => {
	const debug = getDebug()
	if (debug)
		console.log('INFO - Tracking ready')
	try {
		// 1. Get all the the completion criteria stored in the cookie
		const { completionCriteria } = getTask() || {}
		// 2. Get the next completion criterion that must be completed
		const nextCompletionCriterion = (completionCriteria||[]).find(x => x && !x.completed) 
		if (nextCompletionCriterion) {
			if (debug)
				console.log('INFO - Tracking on')

			const { type, ...completionCriterion } = nextCompletionCriterion
			if (!type) {
				console.error('ERROR - Missing required completion criterion type.')
				return
			}
			const trackFn = trackFunction[type]
			if (!trackFn) {
				console.error(`ERROR - Completion criterion type '${type}' is not supported`)
				return
			}

			// 3. Track when the tester is completing this completion criterion
			trackFn(completionCriterion, track, getContext())
		}
	} catch(err) {
		console.error(`ERROR - Tracking failed. Details: ${err.stack||err.message}`)
	}

	return {
		get debug() {
			return getDebug()
		},
		set debug(value) {
			setDebug(value ? true : false)
		},
		get context() {
			return getContext()
		},
		get task() {
			return getTask()
		}
	}
}











